module.exports = __webpack_public_path__ + "static/media/35647292_1946627815361146_6902653043339165696_o.27c062e4.jpg";